"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FLAGS_TOOLTIPS = exports.FlagTooltips = void 0;

var flag_kind_1 = require("./entities/flag-kind");

var FlagTooltips =
/** @class */
function () {
  function FlagTooltips() {
    this._values = {};
    this.set(flag_kind_1.FlagKind.radioactive, '<strong>Radioactive</strong>. This object, or its descendants are using excessive permissions like priviledged containers, host network, etc. See <strong>\"Radioactivity\"</strong> properties on affected <strong>Containers</strong> and <strong>Launchers</strong>.');
    this.set(flag_kind_1.FlagKind.xnamespace, '<strong>Spy</strong>. This object, or its descendants have access to Kubernetes APIs beyond the namespace. See <strong>\"Resource Role Matrix\"</strong> properties on affected <strong>Service Accounts</strong> and <strong>Role Bindings</strong>.');
    this.set(flag_kind_1.FlagKind.shared, '<strong>Shared</strong>. This object is shared and any changes would cascade to dependents. See <strong>\"Shared With\"</strong> properties for list of dependents.');
  }

  FlagTooltips.prototype.set = function (key, value) {
    this._values[key] = value;
  };

  FlagTooltips.prototype.get = function (key) {
    var value = this._values[key];

    if (!value) {
      return null;
    }

    return value;
  };

  return FlagTooltips;
}();

exports.FlagTooltips = FlagTooltips;
exports.FLAGS_TOOLTIPS = new FlagTooltips();